import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import { BimViewer } from '../features/Bim/BimViewer'

const Bim = () => {

    return (
        <Page header='BIM' subheader='this is a BIM Demo'>
            <BimViewer></BimViewer>
        </Page>
    )
}


export default withAITracking(reactPlugin, Bim);